module.exports = __webpack_public_path__ + "img/new_link_pic.d161fa03.png";